<table
  mat-table
  [dataSource]="orderedSegments()"
  class="recording-segment-table"
  [class.recording-segment-table--disabled]="disabled()"
>
  <ng-container matColumnDef="playback">
    <th mat-header-cell *matHeaderCellDef class="col-playback"></th>
    <td mat-cell *matCellDef="let segment">
      <button
        class="recording-segment-table__play-button"
        mat-icon-button
        [disabled]="disabled()"
        (click)="onPlayClicked(segment.artifact_id)"
      >
        @if (getIsActiveSegment(segment.artifact_id) && isPlaying()) {
          <mat-icon>pause</mat-icon>
        } @else {
          <mat-icon>play_arrow</mat-icon>
        }
      </button>
    </td>
  </ng-container>

  <ng-container matColumnDef="index">
    <th mat-header-cell *matHeaderCellDef class="col-index">#</th>
    <td mat-cell *matCellDef="let i = index">{{ i + 1 }}</td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef class="col-name">
      {{ 'TRANS__FIELD__RECORDING_SEGMENT' | translate }}
    </th>
    <td mat-cell *matCellDef="let segment">
      <a
        [routerLink]="['/artifact', segment.artifact_id, 'overview']"
        class="recording-segment-table__segment-link"
        [class.recording-segment-table__link--disabled]="disabled()"
      >
        <span>
          <mat-icon>
            {{ objectTypeToMatSymbol('recording') }}
          </mat-icon>
        </span>
        {{ segment.artifact_name }}
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="description">
    <th mat-header-cell *matHeaderCellDef class="col-description">
      {{ 'TRANS__FIELD__RECORDING_SEGMENT__REMARKS' | translate }}
    </th>
    <td mat-cell *matCellDef="let segment">{{ segment.remarks }}</td>
  </ng-container>

  <ng-container matColumnDef="start">
    <th mat-header-cell *matHeaderCellDef class="col-start">
      {{ 'TRANS__FIELD__RECORDING_SEGMENT__START__SHORT' | translate }}
    </th>
    <td mat-cell *matCellDef="let segment">
      {{ msToTimecode(segment.start) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="end">
    <th mat-header-cell *matHeaderCellDef class="col-end">
      {{ 'TRANS__FIELD__RECORDING_SEGMENT__END__SHORT' | translate }}
    </th>
    <td mat-cell *matCellDef="let segment">
      {{ msToTimecode(segment.end) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="duration">
    <th mat-header-cell *matHeaderCellDef class="col-duration">
      {{ 'TRANS__FIELD__RECORDING_SEGMENT__DURATION' | translate }}
    </th>
    <td mat-cell *matCellDef="let segment">
      {{ msToTimecode(getSegmentDuration(segment)) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef class="col-actions"></th>
    <td mat-cell *matCellDef="let segment">
      <a
        mat-icon-button
        [routerLink]="['/artifact', segment.artifact_id, 'overview']"
        [queryParams]="{ edit: true }"
        [class.recording-segment-table__link--disabled]="disabled()"
      >
        <mat-icon>edit</mat-icon>
      </a>
    </td>
  </ng-container>

  <tr
    mat-header-row
    *matHeaderRowDef="displayedColumns"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns;"
    [ngClass]="{
      'recording-segment-table__row--active': getIsActiveSegment(row.artifact_id)
    }"
  ></tr>
</table>
